import script from "./ModalResumenPago.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalResumenPago.vue?vue&type=script&setup=true&lang=js"

import "./ModalResumenPago.vue?vue&type=style&index=0&id=2c457e54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c457e54"]])

export default __exports__